module.exports = __webpack_public_path__ + "static/img/right-arrow.adcc6861.png";